<template>
    <div
        id="login"
        :class="opetype == '2' ? 'register' : ''"
    >
        <img
            class="bg-img"
            src="@/assets/images/login_bg.jpg"
            alt=""
        />
        <div class="login-top">
            <!-- <img src="@/assets/images/icon/logo.png" class="login-logo"> -->
            {{ schoolName }}网络报名
        </div>
        <div
            class="login-box"
            :class="opetype == '2' ? 'lregister' : ''"
        >
            <el-tabs
                class="main_tabs"
                v-model.trim="activeName"
                type="border-card"
            >
                <el-tab-pane
                    :label="'您好，欢迎' + ope"
                    name="login"
                >
                    <el-form
                        :model="form"
                        ref="form"
                        class="formarea"
                    >
                        <el-form-item
                            label-width="64px"
                            label="身份证"
                            v-if="
                                loginType == '3' ||
                                loginType == '4' ||
                                opetype == '2'
                            "
                        >
                            <el-input
                                placeholder="请输入身份证"
                                type="text"
                                v-model.trim="idCard"
                                :prefix-icon="iconidCard"
                                @focus="changeIcon(4, 'el-icon-idcard_sel')"
                                @blur="changeIcon(4, 'el-icon-idcard')"
                                @input="checkLogin()"
                                clearable
                                maxlength="18"
                                @keyup.enter.native="userLogin(1)"
                            ></el-input>
                        </el-form-item>
                        <div
                            v-if="IdcardErr"
                            style="color: red; text-align: center"
                        >
                            身份证格式有误
                        </div>
                        <el-form-item
                            label-width="64px"
                            label="姓名"
                            v-if="opetype == '2'"
                            style="margin: 20px 0"
                        >
                            <el-input
                                placeholder="请输入姓名"
                                type="text"
                                v-model.trim="rname"
                                :prefix-icon="iconpwd"
                                @focus="changeIcon(1, 'el-icon-pwd_sel')"
                                @blur="changeIcon(1, 'el-icon-pwd')"
                                @input="checkLogin()"
                                clearable
                                maxlength="18"
                                @keyup.enter.native="userLogin(1)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label-width="64px"
                            :label="loginText"
                            v-if="loginType == '3' || loginType == '4'"
                            style="margin: 20px 0"
                        >
                            <el-input
                                :placeholder="'请输入' + loginholer"
                                v-model.trim="username"
                                :show-password="loginType == '3' ? true : false"
                                :prefix-icon="iconuser"
                                @focus="changeIcon(0, 'el-icon-user_sel')"
                                @blur="changeIcon(0, 'el-icon-user')"
                                @input="checkAdmin()"
                                clearable
                                @keyup.enter.native="userLogin(1)"
                            ></el-input>
                            <div class="error-msg">
                                <i
                                    class="el-icon-successicon"
                                    v-if="successmsg2 && successmsg2.length > 0"
                                ></i>
                                {{ successmsg2 }}
                                <i
                                    class="el-icon-error2"
                                    v-if="errormsg2 && errormsg2.length > 0"
                                ></i>
                                {{ errormsg2 }}
                            </div>
                        </el-form-item>
                        <el-form-item
                            label-width="64px"
                            label="手机号"
                            v-if="
                                loginType == '1' ||
                                loginType == '2' ||
                                opetype == '2'
                            "
                        >
                            <el-input
                                placeholder="请输入手机号"
                                v-model.trim="mobile"
                                maxlength="11"
                                :prefix-icon="iconphone"
                                @focus="changeIcon(3, 'el-icon-phone_sel')"
                                @blur="changeIcon(3, 'el-icon-phones')"
                                @input="checkSend()"
                                clearable
                                onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                                @keyup.enter.native="userLogin(2)"
                            ></el-input>
                            <div
                                class="invite-box"
                                style="overflow: hidden"
                            >
                                <div class="error-msg">
                                    <i
                                        class="el-icon-error2"
                                        v-if="errormsg4 && errormsg4.length > 0"
                                    ></i>
                                    {{ errormsg4 }}
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label-width="64px"
                            label="验证码"
                            style="margin-top: 20px"
                            v-if="opetype == '2'"
                        >
                            <div
                                class="invite-box"
                                style="overflow: hidden"
                            >
                                <el-input
                                    :placeholder="'请输入验证码'"
                                    v-model.trim="rmobilecode"
                                    :prefix-icon="iconinvite"
                                    @focus="changeIcon(2, 'el-icon-invite_sel')"
                                    @blur="changeIcon(2, 'el-icon-invite')"
                                    @input="checkAdmin()"
                                    clearable
                                    class="checkinput"
                                    @keyup.enter.native="userLogin(2)"
                                ></el-input>
                                <el-button
                                    type="primary"
                                    class="invite-img checkbtn"
                                    :disabled="checksend"
                                    @click="sendCode()"
                                >{{ sendText }}</el-button>
                            </div>
                            <div :class="
                                    successmsg3
                                        ? 'error-msg success'
                                        : 'error-msg'
                                ">
                                <i
                                    class="el-icon-successicon"
                                    v-if="successmsg3 && successmsg3.length > 0"
                                ></i>{{ successmsg3 }}
                                <i
                                    class="el-icon-error2"
                                    v-if="errormsg3 && errormsg3.length > 0"
                                ></i>{{ errormsg3 }}
                            </div>
                        </el-form-item>
                        <el-form-item
                            label-width="64px"
                            :label="loginText"
                            style="margin-top: 20px"
                            v-if="loginType == '1' || loginType == '2'"
                        >
                            <div
                                :class="loginType == '1' ? '' : 'invite-box'"
                                style="overflow: hidden"
                            >
                                <el-input
                                    :placeholder="'请输入' + loginholer"
                                    v-model.trim="mobilecode"
                                    :prefix-icon="iconinvite"
                                    :show-password="
                                        loginType == '1' ? true : false
                                    "
                                    @focus="changeIcon(2, 'el-icon-invite_sel')"
                                    @blur="changeIcon(2, 'el-icon-invite')"
                                    @input="checkAdmin()"
                                    clearable
                                    :class="
                                        loginType == '1' ? '' : 'checkinput'
                                    "
                                    @keyup.enter.native="userLogin(2)"
                                ></el-input>
                                <el-button
                                    v-if="loginType == '2'"
                                    type="primary"
                                    class="invite-img checkbtn"
                                    :disabled="checksend"
                                    @click="sendCode()"
                                >{{ sendText }}</el-button>
                            </div>
                            <div :class="
                                    successmsg2
                                        ? 'error-msg success'
                                        : 'error-msg'
                                ">
                                <i
                                    class="el-icon-successicon"
                                    v-if="successmsg2 && successmsg2.length > 0"
                                ></i>{{ successmsg2 }}
                                <i
                                    class="el-icon-error2"
                                    v-if="errormsg2 && errormsg2.length > 0"
                                ></i>{{ errormsg2 }}
                            </div>
                        </el-form-item>
                    </el-form>
                    <div
                        class="list"
                        v-if="
                            (loginType == '1' || loginType == '3') &&
                            opetype == '1'
                        "
                    >
                        <div class="list-left">
                            <router-link :to="{ name: 'forgotpwd' }">忘记密码</router-link>
                        </div>
                        <div class="list-r">
                            <span
                                style="cursor: pointer"
                                @click="register"
                            >注册账号</span>
                        </div>
                    </div>
                    <div class="button-box top">
                        <el-button
                            type="primary"
                            :disabled="checklogin"
                            @click="userLogin()"
                            v-if="opetype == '1'"
                        >
                            登录
                            <i
                                class="el-icon-loading"
                                v-if="loading"
                            ></i>
                        </el-button>
                        <el-button
                            type="primary"
                            :disabled="checklogin"
                            @click="nowregister()"
                            v-if="opetype == '2'"
                        >
                            立即注册
                            <i
                                class="el-icon-loading"
                                v-if="loading"
                            ></i>
                        </el-button>
                    </div>
                    <div
                        :class="opetype == '2' ? '' : 'list'"
                        v-if="opetype == '2'"
                    >
                        <div
                            class="list-r"
                            style="float: right"
                        >
                            已有账号
                            <span
                                style="cursor: pointer; color: red"
                                @click="gologin"
                            >请登录</span>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="login-intro">
                <div>帮助中心</div>
                <div class="intro-ope">报名说明流程</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            form: {},
            loadings: true,
            loginType: null,
            opetype: 1,
            rmobilecode: null,
            loginText: "姓名",
            loginholer: "",
            loginText1: "姓名",
            loginholer1: "",
            IdcardErr: false,
            login: "登录",
            activeName: "login",
            username: null,
            idCard: null,
            rname: null,
            invitecode: null,
            inviteurl: null,
            errormsg1: null,
            errormsg2: null,
            errormsg4: null,
            successmsg1: null,
            errormsg3: null,
            successmsg3: null,
            successmsg2: null,
            iconuser: "el-icon-user",
            iconpwd: "el-icon-pwd",
            iconphone: "el-icon-phones",
            iconinvite: "el-icon-invite",
            iconidCard: "el-icon-idcard",
            checklogin: true,
            timer: null,
            checksend: true,
            savePwd1: false,
            random: null,
            errorcount: 0,
            mobile: null,
            mobilecode: null,
            loading: true,
            mobileErr: false,
            sendText: "获取验证码",
            ope: "登录",
            compCode: null,
            schoolName: "",
        };
    },
    mounted: async function () {
        const me = this;
        let host = process.env.NODE_ENV === "development" ?  "leling.lndxpt.com" : window.location.host;
        let myDate = new Date();
        this.year = myDate.getFullYear();
        await me.getCompCode(host);
        await me.querySysProp();
        me.loading = false;
    },
    methods: {
        async getCompCode(url) {
            let res = await this.$userService.getCompCode({ realmName: url });
            if (res && res["success"]) {
                this.compCode = res.content.code;
                let schoolName = res.content.schoolName;
                window.document.title = schoolName;
                this.schoolName = schoolName;
            }
        },
        register() {
            let me = this;
            this.opetype = 2;
            this.ope = "注册";
            (me.mobile = null),
                (me.idCard = null),
                (me.name = null),
                (me.pwd = null),
                (me.code = null);
            me.username = null;
            (me.rmobilecode = null),
                (me.mobilecode = null),
                (me.loading = false);
            me.rname = null;
        },
        async nowregister() {
            let me = this;
            let param = {
                mobile: me.mobile,
                idCard: me.idCard,
                name: me.rname,
                pwd: me.username,
                code: me.rmobilecode,
                compCode: me.compCode,
            };
            if (me.loginType == "3") {
                if (/^[A-Za-z0-9]{6,12}$/.test(me.username)) {
                    param.pwd = me.username;
                } else {
                    me.loading = false;
                    me.errormsg2 = " 6-16位数字字母";
                    return;
                }
            }
            if (me.loginType == "1") {
                if (/^[A-Za-z0-9]{6,12}$/.test(me.mobilecode)) {
                    param.pwd = me.mobilecode;
                } else {
                    me.loading = false;
                    me.errormsg2 = " 6-16位数字字母";
                    return;
                }
            }
            let res = await me.$userService.register(param);
            if (res && res["success"]) {
                me.$message({
                    message: "注册成功",
                    type: "success",
                });
                me.opetype = "1";
                (me.mobile = null),
                    (me.idCard = null),
                    (me.name = null),
                    (me.pwd = null),
                    (me.code = null);
                (me.rname = null),
                    (me.rmobilecode = null),
                    (me.mobilecode = null),
                    (me.username = null),
                    (me.loading = false);
            }
        },
        async querySysProp() {
            let me = this;
            let res = await me.$userService.querySysProp({
                compCode: me.compCode,
                key: "webreg.leave.login.type",
            });
            if (res && res["success"]) {
                me.loginType = res.content;
                switch (me.loginType) {
                    case "1":
                        me.loginText = "密码";
                        me.loginholer = "密码（6-16位数字字母）";
                        break;
                    case "2":
                        me.loginText = "验证码";
                        break;
                    case "3":
                        me.loginText = "密码";
                        me.loginholer = "密码（6-16位数字字母）";
                        break;
                    case "4":
                        me.loginText = "姓名";
                        me.loginholer = "姓名";
                        break;
                }
            }
        },
        checkSend() {
            let me = this;
            if (me.mobile && me.mobile.length == 11) {
                if (/^1[3456789]\d{9}$/.test(me.mobile)) {
                    me.errormsg4 = null;
                    me.checksend = false;
                } else {
                    me.errormsg4 = "手机格式有误";
                    this.mobileErr = true;
                    me.checksend = true;
                    return true;
                }
            } else {
                me.checksend = true;
                return true;
            }

            me.checkAdmin();
        },
        checkLogin() {
            let me = this;
            if (me.idCard) {
                if (
                    this.opetype == "2" &&
                    me.rname &&
                    me.rname.length > 0 &&
                    me.mobile
                ) {
                    this.checkAdmin();
                }
                if (
                    this.opetype == "1" &&
                    me.username &&
                    me.username.length > 0
                ) {
                    me.checklogin = false;
                }
            } else {
                me.checksend = true;
                me.checklogin = true;
            }
        },
        checkAdmin() {
            let me = this;
            let str =
                this.loginType == "1"
                    ? me.mobilecode
                    : this.loginType == "3"
                    ? me.username
                    : null;
            if (this.opetype == "1") {
                if (this.loginType == "1") {
                    if (
                        me.mobile &&
                        me.mobile.length > 0 &&
                        me.mobilecode &&
                        me.mobilecode.length > 0
                    ) {
                        me.checklogin = false;
                    } else {
                        me.checklogin = true;
                    }
                }
                if (this.loginType == "3" || this.loginType == "4") {
                    if (
                        me.idCard &&
                        me.idCard.length > 0 &&
                        me.username &&
                        me.username.length > 0
                    ) {
                        me.checklogin = false;
                    } else {
                        me.checklogin = true;
                    }
                }
                if (this.loginType == "2") {
                    if (
                        me.mobile &&
                        me.mobile.length > 0 &&
                        me.mobilecode &&
                        me.mobilecode.length > 0
                    ) {
                        me.checklogin = false;
                    } else {
                        me.checklogin = true;
                    }
                }
            }

            if (this.opetype == "2") {
                if (
                    me.mobile &&
                    me.idCard &&
                    me.idCard.length > 0 &&
                    me.mobile.length > 0 &&
                    me.rmobilecode &&
                    me.rmobilecode.length > 0
                ) {
                    if (this.loginType == "3") {
                        if (me.username && me.username.length > 0) {
                            me.checklogin = false;
                        } else {
                            me.checklogin = true;
                        }
                    }
                    if (this.loginType == "1") {
                        if (me.mobilecode && me.mobilecode.length > 0) {
                            me.checklogin = false;
                        } else {
                            me.checklogin = true;
                        }
                    }
                } else {
                    me.checklogin = true;
                }
            }

            me.successmsg2 = null;
            me.errormsg2 = null;
        },
        async sendCode() {
            let me = this,
                type;
            me.successmsg3 = null;
            me.successmsg2 = null;
            me.successmsg1 = null;
            me.errormsg3 = null;
            me.errormsg2 = null;
            me.errormsg1 = null;
            me.errormsg4 = null;
            me.checksend = true;
            me.sendText = 60 + "s";
            if (this.opetype == "2") {
                type = 4;
            }
            if (this.opetype == "1") {
                type = 2;
            }
            me.timer = setTimeout(function () {
                me.countDown(60);
            }, 1000);
            let res = await me.$userService.sendCode(
                me.mobile,
                type,
                me.compCode
            );
            if (res && res["success"]) {
                if (me.opetype == "2") {
                    me.successmsg3 = res["content"]["msg"];
                }
                if (me.opetype == "1") {
                    me.successmsg2 = res["content"]["msg"];
                }
            } else {
                me.checksend = false;
                me.successmsg2 = null;
                clearInterval(me.timer);
                if (this.opetype == "2") {
                    this.rmobilecode = null;
                }
                me.sendText = "获取验证码";
                let msg = res["errmsg"];
                // if (msg == null || msg == undefined || msg == "undefined") {
                //    if(me.opetype=='2'){
                //       me.errormsg3="发生未知错误，请稍后重试！";
                //     }
                //     if(me.opetype=='1'){
                //         me.errormsg2 = "发生未知错误，请稍后重试！";
                //     }
                // } else {
                //     if(me.opetype=='2'){
                //      me.errormsg3 = msg;
                //     }
                //     if(me.opetype=='1'){
                //         me.errormsg2 = msg;
                //     }
                // }
            }
        },
        countDown(num) {
            let me = this;
            if (num > 0) {
                num = num - 1;
                me.sendText = num + "s";
                setTimeout(function () {
                    me.countDown(num);
                }, 1000);
            } else {
                me.checksend = false;
                me.successmsg2 = null;
                me.errormsg2 = null;
                if (this.opetype == "2") {
                    this.rmobilecode = null;
                }
                clearInterval(me.timer);
                me.sendText = "获取验证码";
            }
        },
        changeIcon(type, text) {
            let me = this;
            switch (type) {
                case 0:
                    me.iconuser = text;
                    break;
                case 1:
                    me.iconpwd = text;
                    break;
                case 2:
                    me.iconinvite = text;
                    break;
                case 3:
                    me.iconphone = text;
                    break;
                case 4:
                    me.iconidCard = text;
                    break;
            }
        },

        userLogin: async function () {
            let me = this;
            if (!me.checklogin) {
                me.loading = true;
                me.checklogin = true;
                let param = {};

                switch (me.loginType) {
                    case "3":
                        if (/^[A-Za-z0-9]{6,12}$/.test(me.username)) {
                            param.userName = me.idCard;
                            param.pwd = me.username;
                        } else {
                            me.loading = false;
                            me.errormsg2 = " 6-16位数字字母";
                            return;
                        }

                        break;
                    case "4":
                        param.userName = me.idCard;
                        param.name = me.username;
                        break;
                    case "1":
                        if (!/^1[3456789]\d{9}$/.test(me.mobile)) {
                            me.errormsg4 = " 输入有效手机号";
                            me.loading = false;
                            return;
                        }
                        if (/^[A-Za-z0-9]{6,12}$/.test(me.mobilecode)) {
                            param.userName = me.mobile;
                            param.pwd = me.mobilecode;
                        } else {
                            me.errormsg2 = " 6-16位数字字母";
                            me.loading = false;
                            return;
                        }

                        break;
                    case "2":
                        if (!/^1[3456789]\d{9}$/.test(me.mobile)) {
                            me.errormsg4 = " 输入有效手机号";
                            me.loading = false;
                            return;
                        }
                        param.userName = me.mobile;
                        param.code = me.mobilecode;
                        break;
                }
                param.compCode = me.compCode;
                let res = await me.$userService.userLogin(param);
                if (res && res["success"]) {
                    let userinfo = res.content.data;
                    window.sessionStorage.setItem(
                        "userinfo",
                        JSON.stringify(userinfo)
                    );
                    me.goToPath(res["content"].tokenData);
                } else {
                    me.loading = false;
                    me.checklogin = false;
                    me.checkLogin();
                }
            }
        },
        gologin() {
            let me = this;
            this.opetype = 1;
            (me.mobile = null),
                (me.idCard = null),
                (me.name = null),
                (me.pwd = null),
                (me.code = null);
            me.username = null;
            (me.rmobilecode = null),
                (me.mobilecode = null),
                (me.loading = false);
            me.rname = null;
        },
        async goToPath(token) {
            let me = this;
            if (process.env.NODE_ENV === "production") {
                window.sessionStorage.setItem("shareurl", "/oreg");
            } else {
                window.sessionStorage.setItem("shareurl", "");
            }
            await me.$httpServe.setToken(token);
            window.sessionStorage.setItem("isagree", true);
            let rs = await me.$userService.checkNeedAuth();
            if (rs && rs["success"]) {
                window.sessionStorage.setItem(
                    "isAttestation",
                    rs["content"].isAttestation
                );
                window.sessionStorage.setItem(
                    "isAllFlag",
                    rs["content"].studentInfo.allFlag
                );
                //  if(rs['content'].isAttestation){

                //    me.$router.push({ name: "verify" });
                //  }else{
                if (rs["content"].studentInfo.allFlag) {
                    me.$router.push({ name: "hello" });
                } else {
                    me.$router.push({ name: "personalinfo" });
                }
                //  }
            } else {
                me.loading = false;
                me.checklogin = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/css/login.css";
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
.el-icon-successicon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
}
#login
    .login-box
    .el-tabs
    .el-tabs__header
    > .el-tabs__nav-wrap
    > .el-tabs__nav-scroll
    > .el-tabs__nav
    .el-tabs__item {
    width: 85%;
}
.top {
    margin-top: 20px;
}
.el-form-item {
    margin-bottom: 0px;
}
#login {
    width: 697px;
    height: 418px;
    position: absolute;
    top: 0%;
    left: 0%;
    right: 0%;
    bottom: 0%;
    margin: auto;
    z-index: 1;

    box-sizing: border-box;

    .bg-img {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: -1;
        object-fit: cover;
    }
    .el-tabs.main_tabs .el-tabs__header .el-tabs__nav {
        background: #fff;
    }
    .el-tabs.main_tabs .el-tabs__header .el-tabs__nav .el-tabs__item.is-active {
        font-weight: normal;
    }
    .bg-login {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
    .error-msg {
        &.success {
            color: #54c743;
        }
        margin: 0px;
    }
    .login-top {
        text-align: center;
        font-size: 34px;
        color: #fff;
        margin-bottom: 20px;
    }
    .login-logo {
        width: 82px;
        height: 51px;
    }
    .list-r {
        span {
            color: #0979c5;
        }
    }
    .list {
        margin-top: 10px;
    }
    .login-box {
        background: #fff;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        .login-intro {
            height: 100%;
            width: 40%;
            padding: 100px 0;
            div {
                height: 44px;
                line-height: 44px;
                font-size: 20px;
                color: #152237;
                margin: 10px 0;
                text-align: center;
            }
            .intro-ope {
                width: 150px;
                color: #ff8d3c;
                border: 1px solid #ff8d3c;
                margin: 0 auto;
                border-radius: 5px;
            }
        }
        .bg-logo {
            width: auto;
            height: 420px;
            margin: 0px 0 0 100px;
            float: left;
        }
        .el-tabs--border-card {
            border: none;
            background: none;
            box-shadow: none;
        }
        .el-tabs {
            width: 60%;
            padding: 20px;
            .el-tabs__header
                > .el-tabs__nav-wrap
                > .el-tabs__nav-scroll
                > .el-tabs__nav {
                width: 100%;
                .el-tabs__item {
                    width: 50%;
                    text-align: center;
                    margin: 0;
                }
            }
            .el-tabs__content {
                padding: 30px;
            }
        }
    }
}
.register {
    height: 600px !important;
    .lregister {
        height: 540px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/user/Login.vue